import type { ActionListItem, ActionListOption } from '@latitude/action-list';

export type DropdownExtraData = {
  text: string;
  /** Option code, e.g. a state abbreviation ("NY") or country code ("US") */
  tag?: string;
};

/**
 * Search matcher for KYC dropdown options.
 *
 * Matches when the search value appears anywhere in the option text, or when
 * it is the start of the option tag. The tag holds the option code, so typing
 * "NY" surfaces "New York" and typing "US" surfaces "United States".
 */
export function matchesDropdownSearch(
  option: ActionListOption<DropdownExtraData>,
  searchValue: string,
): ActionListOption<DropdownExtraData> | undefined {
  const { text, tag } = (option as ActionListItem<DropdownExtraData>).extraData;
  const term = searchValue.toLowerCase();

  if (text.toLowerCase().includes(term)) {
    return option;
  }

  if (tag && tag.toLowerCase().startsWith(term)) {
    return option;
  }

  return undefined;
}
